export const FETCH_TELECALLER_LEADS_START =
  "FETCH_TELECALLER_LEADS_START";
export const FETCH_TELECALLER_LEADS_SUCCESS =
  "FETCH_TELECALLER_LEADS_SUCCESS";
export const FETCH_TELECALLER_LEADS_ERROR =
  "FETCH_TELECALLER_LEADS_ERROR";

  export const FETCH_UNRECEIVED_CALL_LEADS_START =
  "FETCH_UNRECEIVED_CALL_LEADS_START";
export const FETCH_UNRECEIVED_CALL_LEADS_SUCCESS =
  "FETCH_UNRECEIVED_CALL_LEADS_SUCCESS";
export const FETCH_UNRECEIVED_CALL_LEADS_ERROR =
  "FETCH_UNRECEIVED_CALL_LEADS_ERROR";
